var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasEventWebhook(_vm.event) &&
    (_vm.user.is_internal || _vm.user.is_admin || _vm.user.is_master)
    ? _c(
        "span",
        [
          _c("emc-button-icon", {
            attrs: {
              iconSmall: "",
              color: _vm.color,
              loading: _vm.loading,
              text: _vm.text,
              icon: _vm.icon,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.processWebhook()
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }